var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59758 0.205974C2.35616 0.0824678 2.09088 0.0127417 1.81998 0.00158846C1.54908 -0.00956478 1.27897 0.0381193 1.02823 0.141363C0.451906 0.373963 0 1.11993 0 1.74254V11.6598C0 13.1717 0.27936 14.4968 0.82869 15.5987C1.34666 16.6704 2.1695 17.565 3.19386 18.1702C4.20214 18.7576 5.40996 19.0595 6.78211 19.0595C8.15427 19.0595 9.40552 18.7658 10.4607 18.1866C11.4997 17.6244 12.3636 16.7862 12.9574 15.7643C13.5668 14.6933 13.8777 13.4783 13.8577 12.246C13.8577 10.9396 13.5642 9.76136 12.9832 8.74403C12.4189 7.74455 11.6031 6.91026 10.6169 6.32406C9.60526 5.72903 8.45076 5.42118 7.27745 5.4336C6.39905 5.42042 5.52868 5.60258 4.72917 5.96693C4.26258 6.18457 3.83066 6.46998 3.4474 6.81393V1.62742C3.45325 1.33456 3.37666 1.04596 3.22638 0.794598C3.0761 0.543239 2.8582 0.339261 2.59758 0.205974ZM7.28332 15.9863C6.24217 15.9863 5.41466 15.6539 4.75382 14.9702C4.09298 14.2865 3.76667 13.3996 3.76667 12.2683C3.76667 11.137 4.08946 10.2536 4.75382 9.56636C5.41818 8.87913 6.24217 8.5502 7.28332 8.5502C8.32446 8.5502 9.14611 8.88148 9.79873 9.56518C10.4514 10.2489 10.7741 11.137 10.7741 12.2671C10.7741 13.3972 10.4549 14.2818 9.79873 14.969C9.14259 15.6562 8.32329 15.9863 7.28332 15.9863Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoB);
export default __webpack_public_path__ + "static/media/ico-b.a4f4b90386e8e8c8cf046df1b4f15b4f.svg";
export { ForwardRef as ReactComponent };